const ActionTypes = {
  UPDATE_USER: 'UPDATE_USER',
};

module.exports = {
  ActionTypes,
};
